import { render, staticRenderFns } from "./Matrix3Table.vue?vue&type=template&id=70c719ce&scoped=true"
import script from "./Matrix3Table.vue?vue&type=script&lang=js"
export * from "./Matrix3Table.vue?vue&type=script&lang=js"
import style0 from "./Matrix3Table.vue?vue&type=style&index=0&id=70c719ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c719ce",
  null
  
)

export default component.exports